/* Buying-guide bottle cards: turn pure product <li> links into bottle cards.
   Only touches list items whose sole link is a /products/ link (skips "by style"
   items that also carry a /collections/ link). Guides are editorial: no price,
   no stock badge. In-stock cards link to the product page; sold-out cards do not. */
(function () {
  function build(li) {
    var link = li.querySelector('a[href*="/products/"]');
    if (!link) return;
    if (li.querySelector('a[href*="/collections/"]')) return; // mixed prose, leave it
    var m = link.getAttribute('href').match(/\/products\/([a-z0-9\-]+)/i);
    if (!m) return;
    var handle = m[1].split('?')[0];
    // blurb = the li text after the link, minus a leading "($x)" price and "-" or ":"
    var blurb = (li.textContent || '').replace(link.textContent || '', '')
      .replace(/^\s*(\(\$[^)]*\))?\s*[–—:-]?\s*/, '').trim();
    fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
      .then(function (p) {
        var img = p.featured_image || (p.images && p.images[0]) || '';
        if (img && img.indexOf('http') !== 0) img = 'https:' + img;
        var href = link.getAttribute('href');
        var card = document.createElement(p.available ? 'a' : 'div');
        card.className = 'sg-card';
        if (p.available) card.href = href;
        card.innerHTML =
          '<span class="sg-card__img">' + (img ? '<img loading="lazy" src="' + img + '&width=360" alt="' + (p.title || '') + '">' : '') + '</span>' +
          '<span class="sg-card__title">' + ((link.textContent || '').trim() || p.title) + '</span>' +
          (blurb ? '<span class="sg-card__blurb">' + blurb + '</span>' : '');
        li.innerHTML = '';
        li.className = 'sg-item';
        li.appendChild(card);
        li.parentNode.classList.add('sg-grid');
      })
      .catch(function () {});
  }
  function run() {
    document.querySelectorAll('.article__content li').forEach(build);
  }
  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);
})();
